import React from 'react';

const withFormField = Component => ({
  name,
  register,
  errors,
  type,
  options,
  className,
  placeholder,
  ...props
}) => {
  return (
    <div>
      {type === 'select' ? (
        <select className={className} {...register(name)} {...props}>
          {placeholder && (
            <option value="" disabled hidden>
              {placeholder}
            </option>
          )}
          {options?.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : type === 'checkbox' ? (
        <label className={className}>
          <input type="checkbox" {...register(name)} {...props} />
          {props.label}
        </label>
      ) : (
        <Component {...register(name)} placeholder={placeholder} {...props} />
      )}
      {errors?.[name] && <p className="error">{errors?.[name]?.message}</p>}
    </div>
  );
};

export default withFormField;
